import React from 'react';
import { ThemeProvider } from './ThemeProvider';
import { QueryProvider } from './QueryProvider';
import { SnackbarProvider } from './SnackbarProvider';

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <QueryProvider>
      <ThemeProvider>
        <SnackbarProvider>{children}</SnackbarProvider>
      </ThemeProvider>
    </QueryProvider>
  );
};

export { ThemeProvider, useThemeMode } from './ThemeProvider';
export { QueryProvider, queryClient } from './QueryProvider';
export { SnackbarProvider, useSnackbar } from './SnackbarProvider';
